module.exports = __webpack_public_path__ + "static/media/adv7.274cdac6.jpg";